// extracted by mini-css-extract-plugin
export default {"cloudflare":"style_cloudflare__FXcAH"};